<template>
	<div id="styleguide-brand" class="section">
		<h1 class="align-center">Brand</h1>
	</div>
</template>
